import { render } from "./ApplicationPermissionOverride.vue?vue&type=template&id=68b5d706"
import script from "./ApplicationPermissionOverride.vue?vue&type=script&lang=js"
export * from "./ApplicationPermissionOverride.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__